import { MachineFieldTypeEnums } from '@/enums/MachineFieldTypeEnums';
class Identifiers {
    // General sections
    public general: string = 'ba760d69';
    public generalTestSeries: string = '2c66272c';
    public generalTestNumber: string = 'c7462669';
    public generalTrialDate: string = 'a281a053';
    public generalTrialTime: string = 'fe5b392d';
    public generalTemperatureFormat: string = '4cab6ccf';
    public generalUnitFormat: string = 'a2474ff4';
    // fields for creator/editor needs to be added manual...
    public generalCreatedBy: string = '-1';
    public generalCreatedAt: string = '-2';
    public generalEditedBy: string = '-3';
    public generalEditedAt: string = '-4';
    public generalMyMillTimestamp: string = '-5';

    public machineOrder: string = 'd6ce98a7';
    public machineOrderAll: string = 'b68c0fd6';

    public customer: string = '26746771';
    public customerCompany: string = '3c843b54';
    public customerName: string = '11c544b8';
    public customerNumber: string = '462ec8ea';
    public customerCountry: string = 'b30a4d3f';

    public unit: string = '23f43821';
    public unitName: string = '000fce0e';

    public material: string = '89a5a1f3';
    public materialBlend: string = '5de57ab9';
    public materialComponent: string = '67b53883';
    public materialFineness: string = 'a2e89207';
    public materialFinenessUnit: string = 'ca97c4c4';

    public climateTemperature = '5c3fca61';

    public contacts: string = 'cb822b0c';

    public notes: string = '7a62215d';
    public notesInputText: string = '84f05d71';

    // Machine/Process sections
    // blow room
    public blowRoom: string = '5455f249';
    public baleOpenerAutomatic: string = 'd69fe90e';
    public baleOpenerManual: string = 'bf3bedd2';
    public heavyPartSeparator: string = '75fab5ca';
    public preCleaner: string = 'b9fe2cd6';
    public mixer: string = '0128412f';
    public feeder: string = '7f4baff1';
    public fineCleanerOpener: string = '46a9d205';
    public storingDustExtraction: string = 'f56e5b15';
    public foreignPartSeparator: string = 'fb15653d';
    public tBlend: string = '9598c491';
    public BLBOBLHFBLPF: string = '67337a72';
    public BLTO: string = '374b0634';
    public tBlendMaterialComponent: string = 'ae845e96';
    // carding and rest
    public carding: string = 'e1990b6a';
    public integratedDrawFrame: string = '575a70cc';
    public breakerDrawing: string = 'fc29dc69';
    public lapWinding: string = '7a81cb06';
    public combing: string = '1328102b';
    public finisherDrawing: string = 'ce83fd22';
    public roving: string = 'db113404';
    public spinningProcess: string = 'c8eae6fb';
    public cardClothing: string = 'c4142168';
    public cardClothingFurtherInformation: string = 'ff70cc33';

    // Sample sections
    public sample: string = 'e201b399';
    public sampleLaboratory: string = '12b107b4';
    public sampleLaboratoryExtractionPoint: string = 'ab818896';

    // Units
    public unitLinearDensity: string = '17768eac';
    public unitTemperature: string = '75bc99f4';
    public unitFineness: string = '9877fa39';
    public unitTwist: string = 'f3f76d28';
    public unitAlpha: string = '52f59626';

    // AX data fields
    public tabId: string = 'tabId';
    public generalAXProject: string = 'b1849c4c';
    public axCustomerName: string = '11c544b8';
    public axCustomerNumber: string = '462ec8ea';
    public axCountry: string = 'b30a4d3f';
    public axAddress: string = 'e5129ab9';
    public axSearchSerialnumber: string = 'ef58da8f';

    public machineModels: string[] = [
        '32e0de92',
        'e1a3d185',
        'c3ea09c0',
        'af773b07',
        'ed2d6f77',
        '46cd7992',
        '9cfd068f',
        '1426ec5d',
        '07c748ff',
        'f07173e8',
        '310cd0e2',
        'a9858acd',
        '85c7f244',
        '574ef4e3',
        '85c44dec',
        'f425ab2a',
        '2321c35b',
    ];
    public commNumbers: string[] = [
        '41e41131',
        'ea5bb264',
        '700c57e3',
        '89ef657b',
        '2c3ae1a2',
        '3b3d2408',
        'ddbde153',
        'b89b2d24',
        'dd8c26f8',
        '50055116',
        '69b4019a',
        '391286a0',
        'cee2ef70',
        '877994d4',
        'aa5e2010',
        'c797eb69',
        '6f2450a1',
    ];
    public serialNumbers: string[] = [
        'b9cc0d48',
        'dfa54e0e',
        '724c78e9',
        'f6aaa7b0',
        'd52a8a7b',
        '8b26bf85',
        'a18d496e',
        '95d33bdb',
        '33551273',
        '5673dc26',
        'c0eb6efc',
        '2b3fe865',
        'bf5b8835',
        'b522dfa3',
        '8d232d5d',
        '8e71f462',
        'd6f455d7',
    ];
    public softwareVersions: string[] = [
        '39d9a72d',
        'ae351426',
        'ee15132e',
        '511676fa',
        '4f7df951',
        '892595ed',
        '766a3a2c',
        'abf1e22f',
        '5738cbf3',
        '462e9a88',
        '500aa3e0',
        'ec72ac6d',
        '04c97920',
        'abb6ef95',
        '2c35ed1f',
        'a1d040d8',
        'fc3706fb',
    ];

    public machinesPositionMultiplier: number = 100;
    public samplesPositionMultiplier: number = 200;

    // MyMill Unit fields
    public myMillUnits: string = '634f36b2';
    public myMillUnit: string = '09d7e29e';
    public myMillMachine: string = '838f1d23';
    public myMillSerialNumber: string = '3f431bf2';

    // filters
    public filterSortByDataSet = 'cc827c48';
    public filterDatasetsByMe = '87263a52';
    public filterCreatedBy = 'fd04ae0f';
    public filterEditedBy = 'c348f80c';
    public filterTabId = '4c23f5bc';
    public filterCreatedAt = 'eae6e4e0';
    public filterEditedAt = '9fecf542';

    public filterSortByDataSetAll: string[] = [
        this.filterDatasetsByMe,
        this.filterCreatedBy,
        this.filterEditedBy,
        this.filterTabId,
        this.filterCreatedAt,
        this.filterEditedAt];

    // tslint:disable-next-line: no-empty
    constructor() {}

    public GetSectionIdentifier(inFieldIdentifier: string): string {
        let section = '';
        switch (inFieldIdentifier) {
            case '32e0de92':
            case '41e41131':
            case 'b9cc0d48':
            case '39d9a72d':
                section = this.baleOpenerAutomatic;
                break;
            case 'e1a3d185':
            case 'ea5bb264':
            case 'dfa54e0e':
            case 'ae351426':
                section = this.baleOpenerManual;
                break;
            case 'c3ea09c0':
            case '700c57e3':
            case '724c78e9':
            case 'ee15132e':
                section = this.heavyPartSeparator;
                break;
            case 'af773b07':
            case '89ef657b':
            case 'f6aaa7b0':
            case '511676fa':
                section = this.preCleaner;
                break;
            case 'ed2d6f77':
            case '2c3ae1a2':
            case 'd52a8a7b':
            case '4f7df951':
                section = this.mixer;
                break;
            case '46cd7992':
            case '3b3d2408':
            case '8b26bf85':
            case '892595ed':
                section = this.feeder;
                break;
            case '9cfd068f':
            case 'ddbde153':
            case 'a18d496e':
            case '766a3a2c':
                section = this.fineCleanerOpener;
                break;
            case '1426ec5d':
            case 'b89b2d24':
            case '95d33bdb':
            case 'abf1e22f':
                section = this.storingDustExtraction;
                break;
            case '07c748ff':
            case 'dd8c26f8':
            case '33551273':
            case '5738cbf3':
                section = this.foreignPartSeparator;
                break;
            case 'f07173e8':
            case '50055116':
            case '5673dc26':
            case '462e9a88':
                section = this.BLBOBLHFBLPF;
                break;
            case '310cd0e2':
            case '69b4019a':
            case 'c0eb6efc':
            case '500aa3e0':
                section = this.BLTO;
                break;

            case 'a9858acd':
            case '391286a0':
            case '2b3fe865':
            case 'ec72ac6d':
                section = this.carding;
                break;
            case '85c7f244':
            case 'cee2ef70':
            case 'bf5b8835':
            case '04c97920':
                section = this.integratedDrawFrame;
                break;
            case '574ef4e3':
            case '877994d4':
            case 'b522dfa3':
            case 'abb6ef95':
                section = this.breakerDrawing;
                break;
            case '85c44dec':
            case 'aa5e2010':
            case '8d232d5d':
            case '2c35ed1f':
                section = this.lapWinding;
                break;
            case 'f425ab2a':
            case 'c797eb69':
            case '8e71f462':
            case 'a1d040d8':
                section = this.combing;
                break;
            case '2321c35b':
            case '6f2450a1':
            case 'd6f455d7':
            case 'fc3706fb':
                section = this.finisherDrawing;
                break;
            default:
                break;
        }
        return section;
    }

    public GetMachineFieldType(inFieldIdentifier: string): MachineFieldTypeEnums {
        let type = MachineFieldTypeEnums.UNKNOWN;
        if (this.machineModels.some((mm) => mm === inFieldIdentifier)) {
            type = MachineFieldTypeEnums.MODEL;
        } else if (this.commNumbers.some((cn) => cn === inFieldIdentifier)) {
            type = MachineFieldTypeEnums.COMMISSON_NUMBER;
        } else if (this.serialNumbers.some((sn) => sn === inFieldIdentifier)) {
            type = MachineFieldTypeEnums.SERIAL_NUMBER;
        } else if (this.softwareVersions.some((sv) => sv === inFieldIdentifier)) {
            type = MachineFieldTypeEnums.SOFTWARE_VERSION;
        }
        return type;
    }
}

export default Identifiers;
